// Turns a team_roster row into the text printed on a business card.

export type RosterRowForCard = {
  full_name: string | null;
  email: string | null;
  phone: string | null;
  role: string | null;
};

export type CardInfo = {
  name: string;
  title: string;
  cell: string;
  email: string;
};

export const OFFICE_PHONE = '470.823.8816';

// team_roster.role -> title printed on the card.
// Edit freely; anything missing falls back to a Title Cased version of the role.
export const ROLE_TITLES: Record<string, string> = {
  admin: 'Owner',
  sales_director: 'Sales Director',
  asm: 'Area Sales Manager',
  team_lead: 'Team Lead',
  restore_manager: 'Restore Manager',
  roof_specialist: 'Roof Specialist',
  roof_team_manager: 'Roof Team Manager',
  qc: 'Quality Control',
  finance: 'Finance',
  drone_pilot: 'Drone Pilot',
  report_specialist: 'Report Specialist',
  office: 'Office',
  canvasser: 'Field Marketing',
  roof_director: 'Roof Director',
  director_of_operations: 'Director of Operations',
  project_manager: 'Project Manager',
};

export function roleTitle(role: string | null | undefined): string {
  if (!role) return '';
  return (
    ROLE_TITLES[role] ??
    role
      .split('_')
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ')
  );
}

// "(470)695-1201", "4706951201", "+1 470 695 1201" -> "470.695.1201"
export function formatPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  if (digits.length !== 10) return raw.trim();
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
}

export function cardInfoFromRoster(row: RosterRowForCard): CardInfo {
  return {
    name: (row.full_name ?? '').trim(),
    title: roleTitle(row.role),
    cell: formatPhone(row.phone),
    email: (row.email ?? '').trim().toLowerCase(),
  };
}

// What's missing before a card can be printed (empty list = ready).
export function missingCardFields(info: CardInfo): string[] {
  const missing: string[] = [];
  if (!info.name) missing.push('name');
  if (!info.cell) missing.push('cell phone');
  if (!info.email) missing.push('email');
  return missing;
}

export function fileSlug(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'team-member'
  );
}
